import actionFe from 'utils/mw/actionFe.util';

const feSetPosIntentId = actionFe('feSetPosIntentId');

// noinspection JSUnusedGlobalSymbols
export default feSetPosIntentId;
